export class SalesAdvisor {
  id: number;
  name: string;
  email: string;
}
